module.exports = __webpack_public_path__ + "img/exhibits_bg.90a4d2c7.png";